var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6.09961C3 5.54732 3.40747 5.09961 3.91011 5.09961H20.0899C20.5925 5.09961 21 5.54732 21 6.09961C21 6.65189 20.5925 7.09961 20.0899 7.09961H3.91011C3.40747 7.09961 3 6.65189 3 6.09961Z",
    fill: "#90A8C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 12.0996C3 11.5473 3.40747 11.0996 3.91011 11.0996H20.0899C20.5925 11.0996 21 11.5473 21 12.0996C21 12.6519 20.5925 13.0996 20.0899 13.0996H3.91011C3.40747 13.0996 3 12.6519 3 12.0996Z",
    fill: "#90A8C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 18.0996C3 17.5473 3.40747 17.0996 3.91011 17.0996H20.0899C20.5925 17.0996 21 17.5473 21 18.0996C21 18.6519 20.5925 19.0996 20.0899 19.0996H3.91011C3.40747 19.0996 3 18.6519 3 18.0996Z",
    fill: "#90A8C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.4fc6658a6ed4bf578b65c74f372f61ec.svg";
export { ForwardRef as ReactComponent };